import * as React from "react";
import { useTheme } from "@mui/material/styles";
import { Box, Typography, Grid, Paper } from "@mui/material";
import "../../../../assets/styles/audio-question.css";
import Audio from "../../../ui-components/Audio";

export default function GridChoiceAudio({ question, onAnswer = () => {} }) {
  const theme = useTheme();
  const [selectedAnswers, setSelectedAnswers] = React.useState([]);

  React.useEffect(() => {
    setSelectedAnswers([]);
  }, [question]);

  const handleSelectAnswer = (answer) => {
    let newAns = [...selectedAnswers]
    if (newAns.indexOf(answer) === -1) {
        newAns.push(answer)
    } else {
        newAns = newAns.filter(ans => ans !== answer);
    }

    setSelectedAnswers(newAns);
    onAnswer({
        answer: newAns,
        canProceed: newAns.length > 0
    })
  };

  return (
    <React.Fragment>
      <Box className="choices-container" sx={{ px: 4, textAlign: "center" }}>
        
        {question.questionAudio && (
            <Audio audioText={question.questionAudio} />
        )}

        <Grid container spacing={2} sx={{ mt: 2 }}>
          {question.questionList.map((item, index) => (
            <Grid item xs={12} sm={4} key={index}>
              <Paper
                elevation={3}
                sx={{
                  p: 1,
                  textAlign: "center",
                  cursor: "pointer",
                  backgroundColor: selectedAnswers.includes(item.id)
                    ? theme.palette.primary.main
                    : "white",
                  color: selectedAnswers.includes(item.id)
                    ? "white"
                    : theme.palette.primary.main,
                }}
                onClick={() => handleSelectAnswer(item.id)}
              >
                <img
                  src={`https://s3.ap-southeast-2.amazonaws.com/static.lln.training/acsf3-short-quiz-resources/clipart/${item.imageId}.png`}
                  alt={item.id}
                  style={{
                    width: "3rem",
                    height: "3rem",
                    objectFit: "contain",
                  }}
                />

                <Typography variant="h6">{item.id}</Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
    </React.Fragment>
  );
}
